module.exports = __webpack_public_path__ + "static/media/Grandstander-Regular.fd41dbd1.ttf";